var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 1.66675C11.1468 1.66675 11.3334 1.8533 11.3334 2.08341V15.5584L15.0334 11.8501C15.1116 11.7712 15.2181 11.7268 15.3292 11.7268C15.4403 11.7268 15.5468 11.7712 15.625 11.8501L16.2084 12.4417C16.2873 12.52 16.3316 12.6265 16.3316 12.7376C16.3316 12.8487 16.2873 12.9552 16.2084 13.0334L11.1 18.1501C10.9829 18.2673 10.8241 18.3333 10.6584 18.3334H10.3417C10.1764 18.3315 10.0181 18.2658 9.90004 18.1501L4.79171 13.0334C4.71283 12.9552 4.66846 12.8487 4.66846 12.7376C4.66846 12.6265 4.71283 12.52 4.79171 12.4417L5.38337 11.8501C5.46018 11.7717 5.5653 11.7275 5.67504 11.7275C5.78478 11.7275 5.8899 11.7717 5.96671 11.8501L9.66671 15.5584V2.08341C9.66671 1.8533 9.85325 1.66675 10.0834 1.66675H10.9167Z",
    fill: "#FFFDF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownward);
export default __webpack_public_path__ + "static/media/arrow_downward.18e52ad1ede99bcf768756e29a96e758.svg";
export { ForwardRef as ReactComponent };